export default __webpack_public_path__ + "static/media/money_euro_filled_small.e2cee89c.svg";